/**
 * Module definition for reports module. The reports module manages
 * the application's top-level reports view (i.e., /reports).
 *
 * @module routes.error
 */

angular.module('routes.error', [
  'stack',
  'routes.error.ErrorController'
])
.config(
  [
    '$stateProvider',
    function ($stateProvider) {
      'use strict';

      var params = {
        error: null,
        state: null,
        params: null,
        oldState: null,
        oldParams: null,
        unfound: null
      };

      $stateProvider
        .state('routes.badRequest', {
          url: '/400',
          params: params,
          templateUrl: 'routes/error/400.html',
          controller: 'ErrorController'
        })
        .state('routes.notAuthorized', {
          url: '/401',
          params: params,
          templateUrl: 'routes/error/401.html',
          controller: 'ErrorController'
        })
        .state('routes.notFound', {
          url: '/404',
          params: params,
          templateUrl: 'routes/error/404.html',
          controller: 'ErrorController'
        })
        .state('routes.tooManyRequests', {
          url: '/429',
          params: params,
          templateUrl: 'routes/error/429.html',
          controller: 'ErrorController'
        })
        .state('routes.internalError', {
          url: '/500',
          params: params,
          templateUrl: 'routes/error/500.html',
          controller: 'ErrorController'
        })
        .state('routes.serviceUnavailable', {
          url: '/503',
          params: params,
          templateUrl: 'routes/error/503.html',
          controller: 'ErrorController'
        })
        .state('routes.comingSoon', {
          url: '/comingSoon',
          params: params,
          templateUrl: 'routes/error/comingSoon.html',
          controller: 'ErrorController'
        })
        .state('routes.logout', {
          url: '/logout',
          params: params,
          templateUrl: 'routes/error/logout.html',
          controller: 'ErrorController'
        })
        .state('routes.defaultError', {
          url: '/error',
          params: params,
          templateUrl: 'routes/error/default.html',
          controller: 'ErrorController'
        });
    }
  ]
);
